import React from 'react';
import { View, Text, ActivityIndicator, Pressable } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import FileIcon from './FileIcon';
import Unicon from '@/components/General/Unicon';
import { formatSize } from '@/utils/FileManager';

const UploadQueue = ({ queue, onRetry, onCancel }) => {
  if (!queue || queue.length === 0) return null;

  return (
    <View>
      {queue.map((item) => (
        <View key={item.id} style={styles.row}>
          <View style={styles.iconWrap}>
            <FileIcon filename={item.filename} mimeType={item.mimeType} size={28} />
          </View>

          <View style={styles.info}>
            <Text style={styles.name} numberOfLines={1}>{item.filename}</Text>
            <Text style={styles.meta}>{formatSize(item.size || 0)}</Text>
            {item.status === 'uploading' && (
              <View style={styles.progressTrack}>
                <View style={[styles.progressFill, { width: `${item.progress}%` }]} />
              </View>
            )}
            {item.status === 'error' && (
              <Text style={styles.errorText} numberOfLines={1}>{item.error || 'Upload failed'}</Text>
            )}
          </View>

          <View style={styles.actions}>
            {item.status === 'uploading' && (
              <ActivityIndicator size="small" color={styles.activityColor.color} />
            )}
            {item.status === 'done' && (
              <Unicon name="checkmark-circle" size={20} colorVariant="success" />
            )}
            {item.status === 'queued' && (
              <Unicon name="time-outline" size={20} colorVariant="textSecondary" />
            )}
            {item.status === 'error' && (
              <Pressable onPress={() => onRetry?.(item.id)} hitSlop={8} style={styles.actionBtn}>
                <Unicon name="refresh" size={18} colorVariant="primary" />
              </Pressable>
            )}
            {item.status !== 'uploading' && (
              <Pressable onPress={() => onCancel?.(item.id)} hitSlop={8} style={styles.actionBtn}>
                <Unicon name="close" size={18} colorVariant="textSecondary" />
              </Pressable>
            )}
          </View>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create(({ colors }) => ({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
    backgroundColor: colors.surface,
    gap: 12,
  },
  activityColor: {
    color: colors.primary,
  },
  iconWrap: {
    width: 36,
    alignItems: 'center',
    justifyContent: 'center',
  },
  info: {
    flex: 1,
    gap: 3,
  },
  name: {
    fontSize: 13,
    fontWeight: '500',
    color: colors.text,
  },
  meta: {
    fontSize: 11,
    color: colors.textSecondary,
  },
  progressTrack: {
    height: 3,
    borderRadius: 2,
    overflow: 'hidden',
    marginTop: 4,
    backgroundColor: colors.border,
  },
  progressFill: {
    height: '100%',
    borderRadius: 2,
    backgroundColor: colors.primary,
  },
  errorText: {
    fontSize: 11,
    fontStyle: 'italic',
    color: colors.error,
  },
  actions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  actionBtn: {
    padding: 2,
  },
}));

export default UploadQueue;
